module.exports = __webpack_public_path__ + "static/LogoWithName-01812a7e6ad5c36600b707862fe160a0.jpg";